import { get } from 'lodash';

import countriesDetails from '../config/countriesDetails';

export const getAllEEACountries = () => countriesDetails.filter((countryDetails) => countryDetails.eea_country === 'Y');

export const findCountryByCountryCode = (countryCode) =>
	countriesDetails.find((contriesDetails) => contriesDetails.iso_country_code === countryCode);

export const isEEACountry = (countryCode) => get(findCountryByCountryCode(countryCode), 'eea_country', '') === 'Y';

export const getCurrencyDecimalPlaces = (countryCode) => {
	const threeDecimalCountries = ['BHD', 'KWD'];

	if (countryCode === 'JPY') return 0;
	if (threeDecimalCountries.includes(countryCode)) return 3;
	return 2;
};
